import styled from 'styled-components';
import CheckedIcon from '../../../../new-components/svg-icons/CheckedIcon';

interface CheckboxProps {
  checked: boolean;
  onClick?: () => void;
}

const Checkbox = ({ checked, onClick }: CheckboxProps) => {
  return (
    <Container onClick={onClick}>
      <CheckboxInput>
        <div className="checkbox">
          {checked && (
            <CheckedIcon
              styles={{ width: '14px', height: '14px' }}
              fill="#006694"
            />
          )}
        </div>
      </CheckboxInput>
    </Container>
  );
};

const Container = styled.div``;

const CheckboxInput = styled.div`
  display: flex;
  gap: 8px;
  cursor: pointer;

  .checkbox {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    border-radius: 4px;
    border: 1px solid #d3dbe6;
    background: #f7f9fd;
  }

  span {
    font-size: ${props => props.theme.font.sizes.s};
    font-family: materialSemiBold;
    color: ${props => props.theme.light.colors.black};
  }
`;

export default Checkbox;
